import { buildModelManager } from "../builder.js";
const DefaultAbandonedCartAlertSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  checkoutId: true,
  createdAt: true,
  customerId: true,
  sendingScheduledAt: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "abandonedCartAlert";
const pluralModelApiIdentifier = "abandonedCartAlerts";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAbandonedCartAlertSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAbandonedCartAlertSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAbandonedCartAlertSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAbandonedCartAlertSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAbandonedCartAlertSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAbandonedCartAlertSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAbandonedCartAlertSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAbandonedCartAlert",
    operationReturnType: "CreateAbandonedCartAlert",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      abandonedCartAlert: { required: false, type: "CreateAbandonedCartAlertInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAbandonedCartAlertSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAbandonedCartAlerts",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAbandonedCartAlertsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAbandonedCartAlertSelection
  },
  {
    type: "action",
    operationName: "updateAbandonedCartAlert",
    operationReturnType: "UpdateAbandonedCartAlert",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      abandonedCartAlert: { required: false, type: "UpdateAbandonedCartAlertInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAbandonedCartAlertSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAbandonedCartAlerts",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAbandonedCartAlertsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAbandonedCartAlertSelection
  },
  {
    type: "action",
    operationName: "deleteAbandonedCartAlert",
    operationReturnType: "DeleteAbandonedCartAlert",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAbandonedCartAlerts",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAbandonedCartAlert",
    operationReturnType: "UpsertAbandonedCartAlert",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      abandonedCartAlert: { required: false, type: "UpsertAbandonedCartAlertInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAbandonedCartAlertResult": { hasReturnType: false },
      "... on UpdateAbandonedCartAlertResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAbandonedCartAlertSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAbandonedCartAlerts",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAbandonedCartAlertsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAbandonedCartAlertSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "abandonedCartAlertGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AbandonedCartAlertManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAbandonedCartAlertSelection,
  operations
);
export {
  AbandonedCartAlertManager,
  DefaultAbandonedCartAlertSelection
};
//# sourceMappingURL=AbandonedCartAlert.js.map
